module.exports = __webpack_public_path__ + "img/heart-white.569692f1.svg";